import clsx from 'clsx'

import { CardNote } from './CardNote'
import { FootnoteLink } from './FootnoteLink'

interface TileProps {
  className?: string
  children: preact.ComponentChildren
  label: preact.ComponentChildren
  inputId?: string
  footnoteId?: number
  tooltip?: preact.ComponentChild
}

export function Tile({ className, label: title, children, footnoteId, tooltip, inputId }: TileProps) {
  return (
    <label
      className={clsx(
        'relative flex flex-col justify-between p-4 pb-5 bg-white/20 text-white/80 rounded focus-within:ring transition-shadow ring-white/50',
        className,
      )}
      htmlFor={inputId}>
      <div className="relative z-10 flex text-sm font-medium leading-snug">
        <span className={clsx(!!tooltip && (footnoteId ? 'pr-4' : 'pr-2'))}>{title}</span>
        {tooltip && (
          <div
            className={clsx(
              'absolute flex items-center justify-center',
              footnoteId ? 'top-0.5 right-0.5' : '-top-2 -right-2',
            )}>
            {tooltip}
          </div>
        )}
      </div>
      <div className="text-xl font-medium leading-none">{children}</div>

      {!!footnoteId && (
        <CardNote className="w-8 h-8 before:bg-black-20/20">
          <span className="text-right pt-0.5 pr-1.5 text-[11px] font-light">
            <FootnoteLink id={footnoteId}>{footnoteId}</FootnoteLink>
          </span>
        </CardNote>
      )}
    </label>
  )
}
